var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-catalog-products-harry-fox',"addButton":false,"rightMenu":[
    {
      value: 'select_mechanical_rate',
      text: _vm.$t('select_mechanical_rate'),
    } ]},on:{"menuClick":_vm.onMenuClick}},[_c('TextField2',{attrs:{"disabled":true,"id":'excess_mechanical_rate',"ta":'right',"type":'percent',"placeholder":_vm.$t('excess_mechanical_rate'),"label":_vm.$t('excess_mechanical_rate'),"value":_vm.selectedProductDetails.product.excess_mechanical_rate},on:{"blur":_vm.onTextFieldValueChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }